import type { MutationFunctionOptions } from '@apollo/client';
import type { FormikHelpers, FormikValues } from 'formik';
import { redirect } from 'react-router';
import { loginInitialState } from '../../../initial-states/userSignUp.initialState';
import type { UserLoginInterface } from '../../../interfaces/auth.interface';

export function handleSubmitData(
  values: FormikValues,
  formikActions: FormikHelpers<UserLoginInterface>,
  path: string,
  mutationLoader: boolean,
  mutation: (options?: MutationFunctionOptions) => Promise<any>,
) {
  try {
    mutation({
      variables: { input: { ...values } },
    })
      .then((res) => {
        if (res.data === undefined && res.errors !== undefined) {
          return res.errors;
        }
        formikActions.resetForm({
          values: {
            ...loginInitialState,
          },
        });
        !mutationLoader && redirect(path);
      })
      .catch((res) => res);
  } catch (error: any) {
    console.error('handleSubmitData error: ', error);
  }
}
